import React from "react"

import ModalAddUserHeader from "../header/header"
import ModalAddUserNewUser from "../new-user/new-user"
import ModalAddUserSubmit from "../submit/submit"
import ModalAddUserCompanyUsersPortfolio from "../company-users/company-users-portfolio"

export default function ModalAddUserPortfolioUsersForm(props) {

    const stopPropagation = (e) => {
        e.stopPropagation()
        e.preventDefault()
    }

    const search = props.search ? props.search.trim().toLowerCase() : false

    // init company users
    let companyUsers = []
    // only regular users and company managers can see company users
    if (gd.ac.check.company.canSeeCompanyUsers()) {
        if (search) {
            props.companyUsers.map(cu => {
                if (cu.user.name.toLowerCase().includes(search) === true) companyUsers.push(cu)
            })
        } else {
            companyUsers = props.companyUsers;
        }
    }

    if (!companyUsers || companyUsers.length < 1) companyUsers = false

    return (
        <div className="v4-container placement-middle multiselect" onClick={stopPropagation}>
            <ModalAddUserHeader search          = {props.search}
                                onSearchChange  = {props.onSearchChange}
                                onSearchCancel  = {props.onSearchCancel}
                                closeModal      = {props.closeModal}/>

            <div className="main multiselect">
                {companyUsers && <div className="group-name m-b-20 m-t-20">Company users</div>}
                <ModalAddUserCompanyUsersPortfolio companyUsers = {companyUsers}
                                                   selected     = {props.selected}
                                                   onRoleSelect = {props.onRoleSelect}
                                                   onUserClick  = {props.onUserClick}/>
                <ModalAddUserNewUser />
                {!companyUsers && <div className="not-found">No users found</div>}
            </div>

            <ModalAddUserSubmit multiselect     = {true}
                                canSubmit       = {props.canSubmit}
                                onClickSubmit   = {props.onClickSubmit}/>
        </div>
    )
}